namespace GeniuzPOS.Purchase {
    export interface PoBankForm {
        BankId: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        BankShortName: Serenity.StringEditor;
        BankAccount: Serenity.StringEditor;
    }

    export class PoBankForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoBank';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoBankForm.init)  {
                PoBankForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PoBankForm, [
                    'BankId', w0,
                    'BankName', w0,
                    'BankShortName', w0,
                    'BankAccount', w0
                ]);
            }
        }
    }
}
